import {
  motion,
  useReducedMotion,
  useScroll,
  useTransform,
} from "framer-motion";

const EASE = [0.22, 0.61, 0.36, 1];

const LINES = [
  [{ t: "A family office" }],
  [{ t: "built by the" }],
  [{ t: "people " }, { t: "whose", em: true }],
  [{ t: "names are on", em: true }],
  [{ t: "the door.", em: true }],
];

export default function Hero() {
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const parallaxY = useTransform(scrollY, [0, 900], reduce ? [0, 0] : [-20, 60]);

  return (
    <section
      className="hero"
      aria-labelledby="hero-title"
      data-testid="section-hero"
    >
      <motion.div className="hero-media" style={{ y: parallaxY }}>
        <motion.div
          className="hero-media-zoom"
          initial={{ scale: 1.06 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.8, ease: EASE }}
        >
          <picture>
            <source srcSet="/hero.webp" type="image/webp" />
            <img
              src="/hero.jpg"
              alt="Wireframe globe on a dark background"
              width="1584"
              height="672"
              fetchPriority="high"
              data-testid="hero-image"
            />
          </picture>
        </motion.div>
      </motion.div>
      <div className="hero-shade" aria-hidden="true"></div>
      <div className="container hero-inner">
        <motion.p
          className="eyebrow"
          data-testid="hero-eyebrow"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: EASE }}
        >
          Family Office Practice
        </motion.p>
        <h1 id="hero-title" data-testid="hero-title">
          {LINES.map((parts, index) => (
            <span className="hero-line" key={index}>
              <motion.span
                className="hero-line-inner"
                initial={{ y: "112%" }}
                animate={{ y: "0%" }}
                transition={{
                  duration: 0.9,
                  delay: 0.1 + index * 0.11,
                  ease: EASE,
                }}
              >
                {parts.map((part, partIndex) =>
                  part.em ? <em key={partIndex}>{part.t}</em> : part.t
                )}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p
          className="lede"
          data-testid="hero-lede"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.55, ease: EASE }}
        >
          We design and set up family offices for founders and families whose
          lives, companies and assets sit in more than one country. From the
          first conversation to the last signature you work with a co-founder
          or a partner. We never hand a family to an associate.
        </motion.p>
        <motion.div
          className="hero-actions"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.68, ease: EASE }}
        >
          <a
            className="btn btn-primary"
            href="#invite"
            data-testid="hero-primary-button"
          >
            Request a private conversation
          </a>
          <a
            className="btn btn-secondary"
            href="#how"
            data-testid="hero-secondary-button"
          >
            How we work
          </a>
        </motion.div>
      </div>
    </section>
  );
}
